export const headerHeight = '4rem'
